import { MessagesFormData } from ".";
import {
  useGetMessageById,
  usePostMessage,
  usePutMessage,
} from "../../../hooks/Messages";
import { Message, MessageIn } from "../../../services/Api/swagger";
import {
  transformMessagesFormDataToMessage,
  transformMessagesFormDataToMessageIn,
} from "../helpers";

export const useMessages = (selectedId?: number) => {
  // POST MESSAGES
  const {
    isSuccess: isSuccessPostMessage,
    mutate: postMessage,
    error: errorPostMessage,
    isLoading: isFetchingPostMessage,
    reset: resetPostMutation,
  } = usePostMessage();

  const handlePostMessage = (messageToPost: MessageIn) => {
    if (messageToPost) {
      postMessage(messageToPost);
    }
  };

  // PUT MESSAGES
  const {
    mutate: putMessage,
    error: errorPutMessage,
    isLoading: isFetchingPutMessage,
    isSuccess: isSuccessPutMessage,
    reset: resetPutMutation,
  } = usePutMessage();

  const handlePutMessage = async (id: number, messageToPut: Message) => {
    if (messageToPut && id) {
      putMessage({ id, messageToPut });
    }
  };

  // GET MESSAGES
  const {
    mutate: getMessageById,
    error: errorMessage,
    isLoading: isFetchingMessage,
    isSuccess: isSuccessMessage,
    data: message,
  } = useGetMessageById();

  const onSubmit = (values: MessagesFormData) => {
    if (selectedId) {
      const transformedValues = transformMessagesFormDataToMessage(
        selectedId,
        values
      );
      handlePutMessage(selectedId, transformedValues);
    }
    if (!selectedId) {
      const transformedValues = transformMessagesFormDataToMessageIn(values);
      handlePostMessage(transformedValues);
    }
  };

  return {
    isSuccessPostMessage,
    handlePostMessage,
    isFetchingPostMessage,
    errorPostMessage,
    resetPostMutation,
    handlePutMessage,
    isFetchingPutMessage,
    isSuccessPutMessage,
    resetPutMutation,
    errorPutMessage,
    getMessageById,
    isFetchingMessage,
    errorMessage,
    isSuccessMessage,
    message,
    onSubmit,
  };
};
